import { DataField } from "../Label/DataField/DataField"
import { Label } from "../Label/Label"

export const DocumentCard = ({ label, paragraph, body }: { label: string, paragraph?: string, body?: string }) => {
    return <>
        <Label text={label} />
        <DataField paragraph={paragraph} body={body} />
    </>
}